"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWixSDKAdapter = void 0;
var tslib_1 = require("tslib");
exports.createWixSDKAdapter = function (Wix) { return ({
    openColorPicker: function (colorPickerConfig, onColorChanged) {
        return Wix.Styles.openColorPicker(colorPickerConfig, onColorChanged);
    },
    openFontPicker: function (fontPickerConfig, onFontChanged) {
        return Wix.Styles.openFontPicker(fontPickerConfig, onFontChanged);
    },
    getSiteTextPresets: function () {
        return Promise.resolve(Wix.Styles.getSiteTextPresets(function (p) { return p; }));
    },
    navigateToBilling: function (options) { return Wix.Settings.openBillingPage(options); },
    setHelpArticle: function (articleId) { return Wix.Settings.setHelpArticle(articleId); },
    getAllData: function () {
        return new Promise(function (resolve, reject) {
            Wix.Data.Public.getAll(resolve, reject);
        });
    },
    setData: function (key, value, scope) {
        return Wix.Data.Public.set(key, value, { scope: scope }, function () { }, function () { });
    },
    removeData: function (key, scope) {
        return Wix.Data.Public.remove(key, { scope: scope }, function () { }, function () { });
    },
    getSiteColors: function () { return Promise.resolve(Wix.Styles.getSiteColors(function (c) { return c; })); },
    setBooleanParam: function (key, value) { return Wix.Styles.setBooleanParam(key, { value: value }); },
    setFontParam: function (key, value) {
        return Wix.Styles.setFontParam(key, { value: value });
    },
    setNumberParam: function (key, value) { return Wix.Styles.setNumberParam(key, { value: value }); },
    setColorParam: function (key, value) {
        return Wix.Styles.setColorParam(key, { value: value });
    },
    getStyleParams: function () {
        return new Promise(function (resolve) {
            Wix.Styles.getStyleParams(function (params) {
                resolve(tslib_1.__assign({}, params));
            });
        });
    },
}); };
//# sourceMappingURL=wixSDKAdapter.js.map